module.exports = __webpack_public_path__ + "img/968-b966f7.png";